<template>
  <div class="add-or-editor-plan">
    <div class="page_title flex_between">
      <span>{{ reportRoute.is_add | titleText }}</span>

      <el-button type="primary" style="width: 92px" size="medium" @click="back"
        >返回</el-button
      >
    </div>

    <div class="container">
      <div class="add-info-box">
        <el-form
          :model="planForm"
          :rules="rules"
          ref="planFormRef"
          class="info-form"
          label-width="100px"
        >
          <el-divider content-position="left">基本信息</el-divider>
          <el-form-item label="上级分类">{{
            p_conditioning_name
          }}</el-form-item>

          <el-form-item label="排序">
            <el-input-number
              v-model="planForm.sort"
              step-strictly
              :step="1"
              :min="0"
              :max="1000000000"
              :controls="false"
              placeholder="请输入排序"
            ></el-input-number>
            <span style="margin-left: 10px; color: #999"
              >数字越大，排名越靠前,如果为空，默认排序方式为创建时间</span
            >
          </el-form-item>

          <el-form-item label="分类名称" prop="conditioning_name">
            <el-input
              v-model="planForm.conditioning_name"
              maxlength="20"
              style="width: 280px"
              placeholder="不超过20个字"
            ></el-input>
          </el-form-item>

          <el-form-item label="是否显示">
            <el-radio-group v-model="planForm.is_visible">
              <el-radio :label="1">是</el-radio>
              <el-radio :label="0">否</el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item label="分类logo" prop="conditioning_pic">
            <el-upload
              name="image"
              accept=".png,.jpeg,.jpg"
              :show-file-list="false"
              :http-request="getUploadImg"
              action="conditioning_pic"
            >
              <el-button slot="trigger" type="text">上传本地图片</el-button>
              <span style="color: #999; font-size: 12px; margin-left: 10px"
                >图片文件大小在5MB以内，支持png,jpeg,gif格式，最多可上传1张</span
              >
            </el-upload>
          </el-form-item>

          <div v-show="planForm.conditioning_pic_url != ''" class="box">
            <img :src="planForm.conditioning_pic_url" />

            <el-upload
              :show-file-list="false"
              :http-request="getUploadImg"
              action="conditioning_pic"
              accept=".png,.jpeg,.jpg"
            >
              <div class="shadow column-center column">
                <div>
                  <i
                    class="el-icon-search"
                    @click.stop="showImg(planForm.conditioning_pic_url)"
                  ></i>

                  <i class="el-icon-delete" @click.stop="delImg()"></i>
                </div>
              </div>
            </el-upload>
          </div>

          <el-form-item label="描述" prop="conditioning_desc">
            <el-input
              v-model="planForm.conditioning_desc"
              style="width: 280px"
            ></el-input>
          </el-form-item>

          <el-divider content-position="left" class="wangeditor-divider"
            >文案信息</el-divider
          >
          <el-form-item label="" prop="content" class="plan-editor">
            <div class="plan-editor-btn">
              <el-button
                type="primary"
                size="small"
                @click="doctorDialog = true"
                >选择医生</el-button
              >
              <el-button
                type="primary"
                size="small"
                @click="recipeDialog = true"
                >选择处方</el-button
              >
              <el-button type="primary" size="small" @click="goodsDialog = true"
                >选择商品</el-button
              >
            </div>
            <wangeditor ref="planEditorRef" />
          </el-form-item>

          <el-form-item class="btn-box">
            <el-button @click="resetForm('planFormRef')" :disabled="isDisable"
              >取 消</el-button
            >
            <el-button
              type="primary"
              :disabled="isDisable"
              @click="submitForm('planFormRef')"
              >保 存</el-button
            >
          </el-form-item>
        </el-form>
      </div>
    </div>
    <!-- 图片预览 -->
    <el-image-viewer
      class="add-or-editor-plan-img"
      v-if="showViewer"
      :on-close="
        () => {
          showViewer = false;
        }
      "
      :url-list="imgList"
    />
    <!-- 选择医生 -->
    <choose-doctor
      v-if="doctorDialog"
      @close="doctorDialog = false"
      @confirmDoctor="confirmDoctor"
    ></choose-doctor>
    <!-- 选择处方 -->
    <choose-recipe
      v-if="recipeDialog"
      @close="recipeDialog = false"
      @confirmRecipe="confirmRecipe"
    ></choose-recipe>
    <!-- 选择商品 -->
    <choose-goods
      v-if="goodsDialog"
      @close="goodsDialog = false"
      @confirmGoods="confirmGoods"
    ></choose-goods>
  </div>
</template>

<script>
import toningPlan from "../../../../api/toningPlan";
import { uploadImg, getImgUrl } from "../../../../service/common/constant.js";
import wangeditor from "../../wangeditor";
import ChooseDoctor from "../components/chooseDoctor";
import ChooseRecipe from "../components/chooseRecipe";
import ChooseGoods from "../components/chooseGoods";
export default {
  components: {
    "el-image-viewer": () =>
      import("element-ui/packages/image/src/image-viewer"),
    wangeditor,
    ChooseDoctor,
    ChooseRecipe,
    ChooseGoods,
  },
  data() {
    return {
      showViewer: false,
      imgList: [],
      doctorDialog: false,
      recipeDialog: false,
      goodsDialog: false,
      p_conditioning_name: "",
      planForm: {
        conditioning_id: "",
        sort: "",
        conditioning_name: "",
        is_visible: 1,
        conditioning_pic: "",
        conditioning_pic_url: "",
        pid: "",
        content: "",
        conditioning_desc: "",
      },
      uploadExtraData: {
        img_type: 4,
        suffix: ".jpg",
      },
      rules: {
        conditioning_name: [
          { required: true, message: "请输入分类名称", trigger: "blur" },
          { min: 1, max: 20, message: "分类名称20位字符以内", trigger: "blur" },
        ],
        conditioning_pic: [
          { required: true, message: "请上传图片", trigger: "blur" },
        ],
        content: [{ required: true, message: "请填写文案", trigger: "change" }],
      },
      dialogIcon: false,
      options: [],
      chooseDoctorList: [],
      renderDoctor: [],
      chooseGoodsList: [],
      renderGoods: [],
      chooseRecipeList: [],
      renderRecipe: [],
    };
  },
  filters: {
    titleText(val) {
      switch (val) {
        case "-1":
          return "添加方案";
        default:
          return "编辑方案";
      }
    },
  },
  computed: {
    reportRoute() {
      return this.$route.query;
    },
    isDisable() {
      return this.$route.query.status == 2 ? true : false;
    },
    htmlStyle() {
      let obj = {
        boxStyle:
          "width: 100%;  height: 110px; max-width: 420px; border:1px solid #449867; border-radius: 6px;margin: 12px 0; box-sizing: border-box;",
        titleStyle:
          "width: 152px; height: 26px; line-height: 26px; font-size: 14px; text-align: center; background-color: #E7F6EE;border-bottom-right-radius: 6px; border-top-left-radius: 6px;color: #449867; margin-bottom: 16px;",
        nameStyle:
          "width:calc(100% - 20px );font-size: 17px;line-height: 40px; color: #333333; font-weight: bold; text-align: left;overflow: hidden;text-overflow:ellipsis;white-space: nowrap;",
        contentBoxStyle: "width: calc(100% - 56px)",
        contentStyle:
          "width:calc(100% - 20px );font-size: 13px; color: #333333; text-align: left; overflow: hidden;text-overflow:ellipsis;white-space: nowrap;",
        imgStyle: "width: 56px; height: 56px;border-radius: 4px;",
        priceStyle:
          "width:calc(100% - 20px );color:#ff7c0a; font-size:16px;text-align: left;overflow: hidden;text-overflow:ellipsis;white-space: nowrap;",
        btnStyle:
          "width: 88px; height: 28px; line-height: 28px; font-size: 14px; text-align: center; background-color: #449867; border-radius: 14px; color:#ffffff;",
      };
      return obj;
    },
  },
  created() {
    this.init();
  },
  watch: {
    chooseDoctorList: {
      handler: function (newVal, oldVal) {
        this.renderDoctor = _.xorWith(newVal, oldVal, _.isEqual);
        this.renderDoctor.forEach((item, index) => {
          oldVal.forEach((key, i) => {
            if (item.doctor_id == key.doctor_id) {
              delete this.renderDoctor[index];
            }
          });
        });

        this.renderDoctor = this.renderDoctor.filter(function (val) {
          return val;
        });
      },
      deep: true,
    },
    chooseGoodsList: {
      handler: function (newVal, oldVal) {
        this.renderGoods = _.xorWith(newVal, oldVal, _.isEqual);
        this.renderGoods.forEach((item, index) => {
          oldVal.forEach((key, i) => {
            if (item.goods_id == key.goods_id) {
              delete this.renderGoods[index];
            }
          });
        });

        this.renderGoods = this.renderGoods.filter(function (val) {
          return val;
        });
      },
      deep: true,
    },
    chooseRecipeList: {
      handler: function (newVal, oldVal) {
        this.renderRecipe = _.xorWith(newVal, oldVal, _.isEqual);
        this.renderRecipe.forEach((item, index) => {
          oldVal.forEach((key, i) => {
            if (item.pre_agr_id == key.pre_agr_id) {
              delete this.renderRecipe[index];
            }
          });
        });
        this.renderRecipe = this.renderRecipe.filter(function (val) {
          return val;
        });
      },
      deep: true,
    },
  },
  methods: {
    init() {
      if (this.reportRoute.is_add != -1) {
        let params = {
          conditioning_id: this.reportRoute.conditioning_id,
        };
        toningPlan.getConditioningCategoryInfo(params).then((res) => {
          let { info } = res.data;
          this.$refs.planEditorRef.editor.txt.html(info.content);
          this.p_conditioning_name = info.p_conditioning_name;
          this.planForm = {
            conditioning_id: info.conditioning_id,
            sort: info.sort,
            conditioning_name: info.conditioning_name,
            is_visible: Number(info.is_visible),
            conditioning_pic: info.conditioning_pic,
            conditioning_pic_url: info.conditioning_pic_url,
            pid: info.pid,
            content: info.content,
            conditioning_desc: info.conditioning_desc,
          };
        });
      } else {
        this.planForm = Object.assign(this.planForm, this.reportRoute);
        this.planForm.is_visible = Number(this.planForm.is_visible);
        this.planForm.conditioning_name = "";
        this.p_conditioning_name = this.reportRoute.conditioning_name;
      }
    },
    //上传图片
    getUploadImg(params, item) {
      let file = params.file;
      uploadImg(file)
        .then((res) => {
          let { path, pic } = res.data;
          console.log(res.data);
          this.planForm.conditioning_pic = pic;
          this.planForm.conditioning_pic_url = path;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    //查看图片
    showImg(item) {
      console.log(item);
      this.imgList = [item];
      this.showViewer = true;
    },
    //删除图片
    delImg() {
      this.$confirm("此操作将永久删除该文件, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(() => {
          this.planForm.conditioning_pic = "";
          this.planForm.conditioning_path = "";
        })
        .catch(() => {});
    },
    // 医生
    confirmDoctor(data) {
      let allHtml = this.$refs.planEditorRef.editor.txt.html();
      this.chooseDoctorList = data;
      this.$nextTick(() => {
        let arr = allHtml == "" ? data : this.renderDoctor;
        let doctorHtml = "";
        for (let item of arr) {
          let html = `<br /><div class="choose-box doctor" style="${this.htmlStyle.boxStyle}" data-id="${item.doctor_id}">
                      <div class="title doctor" data-id="${item.doctor_id}" style="${this.htmlStyle.titleStyle}">为您推荐：中医专家</div>
                      <div style="height: 60px;display:flex;justify-content: space-between;align-items: center; padding: 0 12px;" class="doctor" data-id="${item.doctor_id}" >
                        <div class="doctor" data-id="${item.doctor_id}" style="${this.htmlStyle.contentBoxStyle}">
                          <div class="name doctor"  data-id="${item.doctor_id}"  style="${this.htmlStyle.nameStyle}">${item.doctor_name}</div>
                          <div class="doctor"   data-id="${item.doctor_id}" style="${this.htmlStyle.contentStyle}">擅长方向：${item.be_good_at}</div>
                        </div>
                        <div class='img-box doctor'  data-id="${item.doctor_id}" style="flex: 0 0 56px;">
                          <img src='${item.head_img}' class="doctor"   data-id="${item.doctor_id}" style="${this.htmlStyle.imgStyle}" />
                        </div>
                      </div>
                    </div>
                    <br />`;
          doctorHtml += html;
        }
        // allHtml += doctorHtml;
        // this.$refs.planEditorRef.editor.txt.html(allHtml);
        this.$refs.planEditorRef.editor.cmd.do("insertHTML", doctorHtml);
      });
    },
    // 处方
    confirmRecipe(data) {
      let allHtml = this.$refs.planEditorRef.editor.txt.html();
      this.chooseRecipeList = data;
      this.$nextTick(() => {
        let arr = allHtml == "" ? data : this.renderRecipe;
        console.log("处方", arr);
        let recipeHtml = "";
        for (let item of arr) {
          let html = `<br /><div class="choose-box pre" data-id="${item.pre_agr_id}"  style="${this.htmlStyle.boxStyle}" >
                      <div class="title pre" data-id="${item.pre_agr_id}" style="${this.htmlStyle.titleStyle}">为您推荐：按方购药</div>
                      <div class="pre" data-id="${item.pre_agr_id}">
                          <div class="pre" data-id="${item.pre_agr_id}" style="display:flex;justify-content: space-between;align-items: center; padding: 0 12px;">
                            <div class="name pre" data-id="${item.pre_agr_id}" style="${this.htmlStyle.nameStyle};height:26px;line-height: 26px;">${item.pre_name}</div>
                            <div class='recipe-btn pre' data-id="${item.pre_agr_id}">
                                <div style="${this.htmlStyle.btnStyle}" class='pre'  data-id="${item.pre_agr_id}"  >立即购买</div>
                            </div>
                        </div class="pre" data-id="${item.pre_agr_id}">
                        <div style="${this.htmlStyle.contentStyle};padding: 0 12px;">调治：${item.diagnosis}</div>
                      </div>
                    </div>
                    <br />`;
          recipeHtml += html;
        }
        // allHtml += recipeHtml;
        // this.$refs.planEditorRef.editor.txt.html(allHtml);
        this.$refs.planEditorRef.editor.cmd.do("insertHTML", recipeHtml);
      });
    },
    // 商品
    confirmGoods(data) {
      let allHtml = this.$refs.planEditorRef.editor.txt.html();
      this.chooseGoodsList = data;
      this.$nextTick(() => {
        let arr = allHtml == "" ? data : this.renderGoods;
        console.log("商品", arr);
        let goodsHtml = "";
        for (let item of arr) {
          let html = `<br /><div class="choose-box good" style="${this.htmlStyle.boxStyle}" data-id='${item.goods_id}'>
                      <div class="title good" style="${this.htmlStyle.titleStyle}" data-id='${item.goods_id}'>为您推荐：养生产品</div>
                      <div class="good" data-id='${item.goods_id}' style="height: 60px;display:flex;justify-content: space-between;align-items: center; padding: 0 12px;">
                        <div class="good" data-id='${item.goods_id}' style="${this.htmlStyle.contentBoxStyle}">
                          <div class="name good" style="${this.htmlStyle.nameStyle}"  data-id='${item.goods_id}'>${item.goods_name}</div>
                          <div style="${this.htmlStyle.priceStyle}" class='good' data-id='${item.goods_id}'>原价:￥${item.price}</div>
                        </div>
                        <div class='img-box good' data-id='${item.goods_id}'  style="flex: 0 0 56px;">
                          <img src='${item.picture}' style="${this.htmlStyle.imgStyle}" class='good' data-id='${item.goods_id}' />
                        </div>
                      </div>
                    </div>
                    <br />`;
          goodsHtml += html;
        }
        // allHtml += goodsHtml;
        // this.$refs.planEditorRef.editor.txt.html(allHtml);
        this.$refs.planEditorRef.editor.cmd.do("insertHTML", goodsHtml);
      });
    },
    submitForm(formName) {
      this.planForm.content = this.$refs.planEditorRef.editor.txt.html();
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (!this.planForm.content) {
            this.$message.error("请填写内容");
            return false;
          }
          let isAdd = this.reportRoute.is_add == -1 ? true : false;
          let params = this.planForm;
          if (isAdd) {
            toningPlan.saveConditioningInfo(params).then((res) => {
              let { code } = res;
              if (code == 0) {
                this.$message.success("保存成功");
                this.back();
              }
            });
          } else {
            toningPlan.editConditioningInfo(params).then((res) => {
              let { code } = res;
              if (code == 0) {
                this.$message.success("编辑成功");
                this.back();
              }
            });
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm(formName) {
      this.back();
      // this.$refs[formName].resetFields();
    },
    back() {
      history.back();
    },
  },
};
</script>

<style lang="scss" scoped>
.add-or-editor-plan {
  text-align: left;
  .container {
    padding: 20px;
    border-radius: 5px;
    .add-info-box {
      min-height: calc(100vh - 120px);
      background: #fff;
      .el-divider__text {
        color: #333;
        font-size: 18px;
        font-weight: bold;
      }
      .box {
        position: relative;
        width: 200px;
        padding-left: 100px;
        &:hover .shadow {
          display: flex;
        }
        img {
          width: 200px;
          height: 200px;
        }
        .shadow {
          position: absolute;
          left: 100px;
          top: 0;
          width: 200px;
          height: 200px;
          background-color: rgba(0, 0, 0, 0.6);
          display: none;
        }
        i + i {
          margin-left: 30px;
          color: #d44747;
        }
        i {
          color: #ffffff;
          font-size: 30px;
          text-align: center;
          cursor: pointer;
        }
      }
      .wangeditor-divider {
        margin-top: 40px;
      }
      .info-form {
        padding: 20px;
        .btn-box {
          ::v-deep .el-form-item__content {
            display: flex;
          }
        }
      }
      .plan-editor {
        width: calc(100% - 200px);
        ::v-deep .el-form-item__content {
          width: 100%;
          position: relative;
          .editor {
            width: 100%;
            z-index: 100;
          }
          .plan-editor-btn {
            width: 400px;
            position: absolute;
            z-index: 101;
            top: 26px;
            right: 0;
            display: flex;
            align-items: center;
            justify-content: space-around;
          }
        }
      }
      ::v-deep .el-form-item__content {
        height: auto;
        display: flex;
        align-items: center;
        .el-radio-group {
          height: 40px;
          display: flex;
          align-items: center;
        }
      }
    }
  }
}
</style>